import React from "react";
import { SkeletonCard } from "@/components/ui/Skeleton";

export interface LoadingCardsProps {
  count?: number;
  animationDelay?: boolean;
}

export function LoadingCards({ count = 5, animationDelay = true }: LoadingCardsProps) {
  return (
    <div className="space-y-6">
      {Array.from({ length: count }).map((_, i) => (
        <div
          key={i}
          className="animate-slideInUp"
          style={animationDelay ? { animationDelay: `${i * 100}ms` } : undefined}
        >
          <SkeletonCard />
        </div>
      ))}
    </div>
  );
}
